import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import GlobalError from './GlobalError.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <GlobalError>
            <App />
        </GlobalError>
    </React.StrictMode>,
)
